import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { pathNameSelector } from 'Store/modules/router/selectors';
import { AccountProps } from 'Containers/Account/types';
import { routes } from 'Constants/routes';
import AccountDeleteInfo from '../AccountDeleteInfo';
import AccountDeleteForm from '../AccountDeleteForm';
import Privacy from './components/Privacy';

const contentScreens = {
  1: Privacy,
  2: AccountDeleteInfo,
  3: AccountDeleteForm,
};

const ROUTES = [
  {
    route: routes.ACCOUNT,
  },
  {
    route: routes.ACCOUNT_DELETE_INFO,
  },
  {
    route: routes.ACCOUNT_DELETE_FORM,
  },
];

const AccountPrivacy = ({ setSubContent }: AccountProps): JSX.Element => {
  const [screen, setScreen] = useState<number>(1);
  const path = useSelector(pathNameSelector);

  useEffect(() => {
    if (path === routes.ACCOUNT) {
      setScreen(1);
    }
  }, [path]);
  const Component = screen && contentScreens[screen];

  return (
    <Switch>
      {ROUTES.map(({ route }) => (
        <Route
          key={route}
          exact
          path={route}
          render={() => <Component setScreen={setScreen} setSubContent={setSubContent} />}
        />
      ))}
    </Switch>
  );
};

export default AccountPrivacy;
